
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiForwardStatic as ObiForwardStaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-forward-static.js';
 
 
 

 
 export const ObiForwardStatic = createComponent({
   react: React,
   tagName: 'obi-forward-static',
   elementClass: ObiForwardStaticElement,
   events: {
     
   }
  });
 
 